export default {
  metadata: {
    version: '1.0.0',
    id: 'toast-1.0.0',
    name: 'JDSToastContainer'
  },
  hierarchy: {
    popup: [
      {
        'popup-container': [
          {
            'root-container': ['jds_toast']
          }
        ]
      }
    ]
  },
  base: {
    popup: {
      priority: 70,
      passive: true
    },
    'popup-container': {
      'flex-direction': '{t_0}',
      size: '{t_1}',
      'padding-top': '{t_2}',
      'padding-right': '{t_3}',
      'padding-bottom': '{t_4}',
      'padding-left': '{t_5}'
    },
    'root-container': {
      'flex-direction': '{t_6}',
      'justify-content': '{t_7}',
      'align-items': '{t_8}',
      size: '{t_9}',
      gap: '{t_10}'
    }
  },
  variant: {},
  combination: [{}],
  combination_config: [[]],
  api: {
    data: {
      'root-container': {
        value: {
          type: 'list',
          name: 'activeToasts',
          object: {
            title: 'string',
            description: 'string',
            primaryCTA: 'string',
            secondaryCTA: 'string',
            showClose: 'boolean',
            dismissAfter: 'number',
            id: 'string',
            prefix: 'string'
          }
        }
      },
      jds_toast: {
        prefix: {
          type: 'string',
          name: 'activeToasts.prefix'
        },
        title: {
          type: 'string',
          name: 'activeToasts.title'
        },
        description: {
          type: 'string',
          name: 'activeToasts.description'
        },
        primaryCTA: {
          type: 'string',
          name: 'activeToasts.primaryCTA'
        },
        secondaryCTA: {
          type: 'string',
          name: 'activeToasts.secondaryCTA'
        },
        showClose: {
          type: 'string',
          name: 'activeToasts.showClose'
        },
        id: {
          type: 'string',
          name: 'activeToasts.id'
        },
        dismissAfter: {
          type: 'number',
          name: 'activeToasts.dismissAfter'
        },
        suffix: {
          type: 'slot',
          name: 'activeToasts.suffix'
        }
      }
    },
    events: {
      jds_toast: {
        onClose: 'onClose',
        onPrimaryClick: 'onPrimaryClick',
        onSecondaryClick: 'onSecondaryClick',
        onShow: 'onShow'
      }
    },
    a11y: {
      jds_toast: {
        properties: {
          closeButtonAriaLabel: 'closeButtonAriaLabel',
          secondaryCtaAriaLabel: 'secondaryCtaAriaLabel',
          secondaryCtaAriaDescribedby: {
            name: 'secondaryCtaAriaDescribedby',
            platform: 'web,ios'
          },
          primaryCtaAriaLabel: 'primaryCtaAriaLabel',
          primaryCtaAriaDescribedby: {
            name: 'primaryCtaAriaDescribedby',
            platform: 'web,ios'
          }
        }
      }
    }
  }
};
